import React, {useEffect} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {generalStore, modalStore} from "../../index";
import {observer} from "mobx-react";
import Utility from "../../Utility";
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';

export const FilePreviewModal = observer(() => {
    const isMobile = Utility.isMobile();

    const CloseModal = async () => {
        modalStore.isFilePreviewModalOpen = false;
        modalStore.resetModalData();
    };

    useEffect(() => {

        modalStore.isFilePreviewModalLoading = true;
        const handleEscKey = (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                CloseModal();
            }
        };

        if (modalStore.isFilePreviewModalOpen) {
            document.addEventListener('keydown', handleEscKey);
        }
        setTimeout(() => {
            modalStore.isFilePreviewModalLoading = false;
        }, 1000);
        return () => {
            document.removeEventListener('keydown', handleEscKey);
        };

    }, [modalStore.isFilePreviewModalOpen]);

    return (
        <ConditionalComponent if={modalStore.isFilePreviewModalOpen}>
            <div>
                {!isMobile && (
                    <div
                        className="fixed inset-0 bg-background-overlay bg-opacity-50"
                        style={{ zIndex: 2002 }}
                        onClick={CloseModal}
                    />
                )}

                <div
                    className={`fixed flex flex-col bg-background-normal text-main-normal ${(modalStore?.modalData?.file?.FileExtension === 'mp4' && isMobile) ? 'pt-16' : ''}
                                ${isMobile ? "w-full h-full top-0 left-0 rounded-none" : "rounded-menu"} 
                                items-center shadow-lg`}
                    style={{
                        zIndex: 2003,
                        top: isMobile ? 0 : "5%",
                        left: isMobile ? 0 : "20%",
                        width: isMobile ? "100%" : "60%",
                        height: isMobile ? "100%" : "90vh",
                        fontSize: "12px",
                        boxShadow: "0 4px 12.5px 0 rgba(0, 0, 0, 0.25)",
                    }}
                >
                        <button
                            onClick={CloseModal}
                            className="absolute top-3 right-3 p-2 rounded-full hover:bg-gray-200"
                            style={{ zIndex: 2003 }}
                        >
                            <CloseIcon size={20} />
                        </button>
                    {modalStore.isFilePreviewModalLoading &&(
                        ( <div style={{
                            width: '100%',
                            height: '80vh',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}> <CircularProgress size={60} /> </div> )
                    )}
                    <div style={{
                        position: 'fixed',
                        top: '50%',
                        left: '50%' ,
                        transform:'translate(-50%, -50%)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        opacity: modalStore.isFilePreviewModalLoading ? 0 : 100,
                        zIndex: 2001,
                        }}>
                        {Utility.renderFilePreview(
                            modalStore.modalData.file,
                            generalStore.translate,
                            CloseModal,
                        )}
                    </div>

                </div>
            </div>
        </ConditionalComponent>
    );
});
